import type { CountryCode } from "../types/countryFields.types";

export interface CountryInfo {
  code: CountryCode;
  name: string;
  currency: string;
  currencySymbol: string;
  flag: string; // ISO code for react-world-flags
  iso3: string; // ISO3 code for API
}

export const COUNTRIES: Record<CountryCode, CountryInfo> = {
  Colombia: {
    code: "Colombia",
    name: "Colombia",
    currency: "COP",
    currencySymbol: "$",
    flag: "CO",
    iso3: "COL",
  },
  Brasil: {
    code: "Brasil",
    name: "Brasil",
    currency: "BRL",
    currencySymbol: "R$",
    flag: "BR",
    iso3: "BRA",
  },
  México: {
    code: "México",
    name: "México",
    currency: "MXN",
    currencySymbol: "$",
    flag: "MX",
    iso3: "MEX",
  },
  Argentina: {
    code: "Argentina",
    name: "Argentina",
    currency: "ARS",
    currencySymbol: "$",
    flag: "AR",
    iso3: "ARG",
  },
  Chile: {
    code: "Chile",
    name: "Chile",
    currency: "CLP",
    currencySymbol: "$",
    flag: "CL",
    iso3: "CHL",
  },
  Ecuador: {
    code: "Ecuador",
    name: "Ecuador",
    currency: "USD",
    currencySymbol: "$",
    flag: "EC",
    iso3: "ECU",
  },
  Panamá: {
    code: "Panamá",
    name: "Panamá",
    currency: "USD",
    currencySymbol: "$",
    flag: "PA",
    iso3: "PAN",
  },
  Perú: {
    code: "Perú",
    name: "Perú",
    currency: "PEN",
    currencySymbol: "S/",
    flag: "PE",
    iso3: "PER",
  },
  Crypto: {
    code: "Crypto",
    name: "Crypto",
    currency: "USDT",
    currencySymbol: "$",
    flag: "XX",
    iso3: "CRY",
  },
  Paraguay: {
    code: "Paraguay",
    name: "Paraguay",
    currency: "PYG",
    currencySymbol: "₲",
    flag: "PY",
    iso3: "PRY",
  },
  Guatemala: {
    code: "Guatemala",
    name: "Guatemala",
    currency: "GTQ",
    currencySymbol: "Q",
    flag: "GT",
    iso3: "GTM",
  },
  "Unión Europea": {
    code: "Unión Europea",
    name: "Unión Europea",
    currency: "EUR",
    currencySymbol: "€",
    flag: "EU",
    iso3: "EUR",
  },
};

export function getCountryInfo(code: CountryCode): CountryInfo | undefined {
  return COUNTRIES[code];
}

export function getAllCountries(): CountryInfo[] {
  return Object.values(COUNTRIES);
}
